import { BASE_API } from "../utils/constants";

export async function getLocationsApi() {

    try {
        const url = `${BASE_API}/api/locations/`;

        const response = await fetch(url);

        const result = await response.json();

        return result;

    } catch (error) {
        throw error;
    }

}

export async function newLocationApi(data, token){
    //console.log(data.image);
    //console.log(token);
    try {
        //CUADNO TRABAJAMOS CON IMAGEN INSTANCIAR FORM DATA       

        const url = `${BASE_API}/api/locations/`;

        const params = {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-type": "application/json"         
            },
            //3
            body: JSON.stringify(data),            
        };
        const response = await fetch(url, params);

        const result = await response.json();

        return result

    } catch (error) {
        throw error
    }
}

export async function editLocationApi(id, data, token)  {

    try {
        
        const url = `${BASE_API}/api/locations/${id}/`;
        const params = {
            method: 'PATCH',
            headers: {
                Authorization: `Bearer ${token}`, 
                "Content-type": "application/json"            
            },
            body: JSON.stringify(data) 
        }

        const response = await fetch(url, params);
        const result = await response.json();

        return result;

    } catch (error) {
        throw error;
    }


}


export async function deleteLocationApi(id, token)  {
    try {
        const url = `${BASE_API}/api/locations/${id}/`;
        const params = {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`             
            }
        }
        const response = await fetch(url, params);
        const result = await response.json();
        return result;
        
    } catch (error) {
        throw error;
    }
}